import React, { useEffect, useState, useRef } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import useDocDownload from "../app/hooks/useDocDownload";
import { deleteReceivedDocument, getAnyDocumentsLoading, getDocuments, getEsignDocuments, getReceivedDocDeleteStatus, getReqDocuments, getSignedDocumentData, loadDocuments, loadEsignDocuments, loadReqDocuments, loadSignedDocument, receviedDocDeleted, signedDocumentReceived, updateReceivedDocStatus } from "../app/store/documents";
import { getPurchaseOrderDoc, getPurchaseOrders, loadPurchaseOrderDoc, loadPurchaseOrders, purchaseOrderDocReceived } from "../app/store/purchaseOrder";
import { getAlert, getConfirmAlert, getConfirmAlertWithAuth } from "../services/appAlerts";
import moment from "moment";
import CandidateReqDoc from "../components/OMCRegistry/CandidateReqDoc";

const ReceivedDocuments = ({
    item, workflowTask, onCountChange
}) => {

    const [pOrders, setPOrders] = useState([]);
    const [reqDocs, setReqDocs] = useState([]);
    const [appDocuments, setAppDocuments] = useState([]);
    const [esignDocs, setEsignDocs] = useState([]);
    const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
    const [signLoading, setSignLoading] = useState(false);
    const [deleteType, setDeleteType] = useState("");
    const [esignLinkCache, setEsignLinkCache] = useState({});
    const [esignLinkLoadingKey, setEsignLinkLoadingKey] = useState(null);
    const [docShowHide, setDocShowHide] = useState(false);
    const [uploadDocType, setUploadDocType] = useState("");
    const [activeNotesDocId, setActiveNotesDocId] = useState(null);

    const handleDocShowHide = (action) => {
        setDocShowHide(!docShowHide);
        if (action === "save") {
            dispatch(loadDocuments(workflowTask.ciid));
            dispatch(loadReqDocuments(workflowTask.ciid));
        }
    };

    const getUploadType = () => {
        const pData = item?.performerData;
        if (pData) {
            try {
                const parsed = typeof pData === "string" ? JSON.parse(pData) : pData;
                if (parsed.subcontractorenrollmentform) return "Subcontractor";
                if (parsed.recruiterenrollmentform) return "Recruiter";
                if (parsed.candidateonboardingform) return "Candidate";
            } catch (e) {
                // ignore
            }
        }
        if (item?.subcontractor) return "Subcontractor";
        if (item?.recruiter) return "Recruiter";
        if (item?.applications?.[0]?.applicationType) {
            const appType = item.applications[0].applicationType;
            if (appType.toLowerCase().includes("subcontractor")) return "Subcontractor";
            if (appType.toLowerCase().includes("recruiter")) return "Recruiter";
        }
        return "Candidate";
    };

    const documentsSelector = useSelector(getDocuments);
    const isLoading = useSelector(getAnyDocumentsLoading);
    const purchaseOrdersSelector = useSelector(getPurchaseOrders);
    const reqDocumentsSelector = useSelector(getReqDocuments);
    const purchaseOrderDocSelector = useSelector(getPurchaseOrderDoc);
    const esignDocumentsSelector = useSelector(getEsignDocuments);
    const signedDocumentDataSelector = useSelector(getSignedDocumentData);
    const receivedDocDeleteStatusSelector = useSelector(getReceivedDocDeleteStatus);

    const [handleDownloadFile] = useDocDownload();
    const dispatch = useDispatch();

    const getWorkbenchApiBaseUrl = () => (process?.env?.REACT_APP_API_BASEURL || "").replace(/\/$/, "");

    const getEsignApiBaseUrl = () =>
        process?.env?.REACT_APP_ESIGN_API_BASEURL ||
        process?.env?.REACT_APP_ESIGN_API_URL ||
        (window.location.hostname === "localhost" ? "http://localhost:5005" : "");

    const getReceivedEsignDocumentId = (doc) =>
        doc?.documentId || doc?.DocumentId || doc?.sourceDocumentId || doc?.docId;

    const getReceivedEsignToken = (doc) =>
        doc?.evelopId || doc?.EvelopId || doc?.preparationToken || doc?.eSignPreparationToken || doc?.ESignPreparationToken || doc?.esignPreparationToken;

    const resolveReceivedEsignLinks = async (doc) => {
        const sourceDocumentId = getReceivedEsignDocumentId(doc);
        const cacheKey = sourceDocumentId || doc?.id;

        if (cacheKey && esignLinkCache[cacheKey]) {
            return esignLinkCache[cacheKey];
        }

        if (sourceDocumentId && doc.type === "esign") {
            const response = await fetch(`${getWorkbenchApiBaseUrl()}/api/ReviewForm/GetDocumentESignLinks?docId=${sourceDocumentId}`);
            const data = await response.json().catch(() => null);

            if (response.ok && data) {
                setEsignLinkCache((current) => ({ ...current, [cacheKey]: data }));
                return data;
            }
        }

        const token = getReceivedEsignToken(doc);
        const apiBaseUrl = getEsignApiBaseUrl();
        const esignBaseUrl = window.location.hostname === "localhost" ? "http://localhost:5173" : (process?.env?.REACT_APP_ESIGN_BASEURL || "http://localhost:5173");

        if (token && apiBaseUrl) {
            const links = {
                prepare: `${esignBaseUrl}/prepare/${token}`,
                details: `${esignBaseUrl}/documents/${token}/details`,
                logs: `${esignBaseUrl}/documents/${token}/logs`,
                visibleSigned: `${apiBaseUrl.replace(/\/$/, "")}/api/public/documents/${token}/download/visible-signed?inline=true`,
                finalSigned: `${apiBaseUrl.replace(/\/$/, "")}/api/public/documents/${token}/download/final-signed?inline=true`
            };
            if (cacheKey) {
                setEsignLinkCache((current) => ({ ...current, [cacheKey]: links }));
            }
            return links;
        }

        return null;
    };

    const handleOpenReceivedEsignDocument = async (doc, linkType) => {
        if (!linkType) return;
        const loadingKey = `${doc.id}-${linkType}`;

        try {
            setEsignLinkLoadingKey(loadingKey);
            const links = await resolveReceivedEsignLinks(doc);
            const url = links?.[linkType];

            if (url) {
                window.open(url, "_blank");
                return;
            }

            if (linkType === "finalSigned" || linkType === "visibleSigned") {
                if (doc.type === "po") {
                    handleDownloadPoFile(doc, "partner");
                } else {
                    handleDownloadEsignedFile(doc, "1");
                }
                return;
            }

            getAlert("", "Document link is not available.", "error");
        } catch (error) {
            getAlert("", "Unable to open document. Please try again.", "error");
        } finally {
            setEsignLinkLoadingKey(null);
        }
    };

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (workflowTask) {
            setReqDocs([]);
            setPOrders([]);
            setAppDocuments([]);
            setEsignDocs([]);
            dispatch(loadDocuments(workflowTask.ciid));
            dispatch(loadReqDocuments(workflowTask.ciid));
            dispatch(loadPurchaseOrders(item.id));
            dispatch(loadEsignDocuments(item?.id));
        }
    }, [workflowTask])

    useEffect(() => {
        setEsignDocs(esignDocumentsSelector);
    }, [esignDocumentsSelector])

    useEffect(() => {
        setPOrders(purchaseOrdersSelector);
    }, [purchaseOrdersSelector]);

    useEffect(() => {
        setReqDocs(reqDocumentsSelector);
    }, [reqDocumentsSelector])

    useEffect(() => {
        setAppDocuments(documentsSelector);
    }, [documentsSelector]);

    const handleDocStatusChange = (docId, status, type) => {
        dispatch(updateReceivedDocStatus(docId, status, type));
    }

    const handleDeleteFile = async (docId, type) => {
        const confirmDelete = await getConfirmAlertWithAuth(
            "",
            "Are you sure you want to delete this document?",
            "warning"
        );

        if (confirmDelete.isConfirmed) {
            dispatch(deleteReceivedDocument(docId, type));
            setDeleteType(type);
        }
    };

    useEffect(() => {
        if (receivedDocDeleteStatusSelector) {
            getAlert("", "Document deleted successfully", "success");
            setDeleteType("");
            dispatch(receviedDocDeleted(null));
            // Refresh document lists after deletion
            if (deleteType === "doc") {
                dispatch(loadDocuments(workflowTask.ciid));
            } else if (deleteType === "req") {
                dispatch(loadReqDocuments(workflowTask.ciid));
            } else if (deleteType === "po") {
                dispatch(loadPurchaseOrders(item.id));
            } else if (deleteType === "esign") {
                dispatch(loadEsignDocuments(item?.id));
            }
        }
    }, [receivedDocDeleteStatusSelector]);

    const getReqRefDocs = (item) => {
        if (item.refDocId > 0) {
            const findDocs = appDocuments.filter(x => x.uploadId === item.refDocId && x.deleteFlag !== true);
            if (findDocs.length > 0) {
                return <>
                    {findDocs.map(doc =>
                        <div className="rt-rd-doc-info" key={doc.docId}>
                            <div className="rt-rd-file-icon is-req">
                                <i className="fa fa-folder-open-o" aria-hidden="true" />
                            </div>
                            <div className="rt-rd-card-title-area">
                                <span style={{ fontWeight: "500", color: "#1e293b", fontSize: "14px" }}>{item.documnetName}</span>
                                <div style={{ marginTop: "2px" }}>
                                    {getReqUploadedDocs(item, "req")}
                                </div>
                            </div>
                        </div>
                    )}
                </>
            }
        }

        return (
            <div className="rt-rd-doc-info">
                <div className="rt-rd-file-icon is-req">
                    <i className="fa fa-folder-open-o" aria-hidden="true" />
                </div>
                <div className="rt-rd-card-title-area">
                    <span style={{ fontWeight: "500", color: "#1e293b", fontSize: "14px" }}>{item.documnetName}</span>
                    <div style={{ marginTop: "2px" }}>
                        {getReqUploadedDocs(item, "req")}
                    </div>
                </div>
            </div>
        );
    }

    const getReqUploadedDocs = (item, type) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );

        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <>
                <button
                    className="btn btn-link btn-sm p-0"
                    title="Download Document"
                    onClick={() => handleDownloadFile(doc)}
                    style={{ fontSize: "14px", fontWeight: "500", color: "#1e293b" }}
                >
                    <i className="fa fa-download mr-1" aria-hidden="true" />
                    {doc.docName}
                </button>
            </>
        }

        return <span className="text-muted" style={{ fontSize: "14px", fontWeight: "400", color: "#64748b" }}>No document uploaded</span>;
    }

    const getReqUploadedNotes = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );

        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return doc.remarks || "";
        }

        return "";
    }

    const getReqUploadedSize = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}`
        );
        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return <span className="rt-rd-size-badge">{doc.docSize}</span>
        }

        return null;
    }

    const getReqDeleteAction = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );
        if (achDocs.length > 0) {
            const doc = achDocs[0];
            return (
                <button
                    className="rt-rd-delete-btn"
                    title="Delete File"
                    onClick={() => handleDeleteFile(doc.docId, "doc")}
                >
                    <i className="fa fa-trash"></i>
                </button>
            );
        }

        return (
            <button
                className="rt-rd-delete-btn"
                title="Delete File"
                onClick={() => handleDeleteFile(item.id, "req")}
            >
                <i className="fa fa-trash"></i>
            </button>
        );
    }

    const getReqStatusBadge = (item) => {
        const achDocs = appDocuments.filter(
            (x) => x.updType === `req_${!item.id ? item.docId : item.id}` && x.deleteFlag !== true
        );
        if (achDocs.length > 0) {
            return (
                <span className="rt-rd-status-badge is-received">
                    Received
                </span>
            );
        }

        if (item.sendStatus === true) {
            return (
                <span className="rt-rd-status-badge is-sent">
                    Sent
                </span>
            );
        }

        return (
            <span className="rt-rd-status-badge is-draft">
                Not Sent
            </span>
        );
    }

    const handleDownloadPoFile = async (item, type) => {
        dispatch(loadPurchaseOrderDoc(item.id, type));
    };

    useEffect(() => {
        if (purchaseOrderDocSelector?.uploadUrl === null) {
            getAlert("", "Document Not Found", "error");
            dispatch(purchaseOrderDocReceived(null));
        } else if (purchaseOrderDocSelector?.uploadUrl) {
            window.open(purchaseOrderDocSelector?.uploadUrl, "_blank");
            dispatch(purchaseOrderDocReceived(null));
        }
    }, [purchaseOrderDocSelector]);

    const handleDownloadEsignedFile = async (item, type) => {
        setSelectedSignedDoc(item);
        setSignLoading(true);
        dispatch(loadSignedDocument(item.id, type));
    }

    useEffect(() => {
        if (signedDocumentDataSelector && selectedSignedDoc) {
            window.open(signedDocumentDataSelector?.uploadUrl, "_blank");
            setSelectedSignedDoc(null);
            setSignLoading(false);
            dispatch(signedDocumentReceived(null));
        }
    }, [signedDocumentDataSelector])

    const getPopover = (notes, uniqueId) => {
        const popover = (
            <Popover id={`popover-${uniqueId}`}>
                <Popover.Title as="h4">Notes</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger
                trigger={[]}
                placement="top"
                overlay={popover}
                show={activeNotesDocId === uniqueId}
                onToggle={(show) => {
                    if (!show) setActiveNotesDocId(null);
                }}
                rootClose
            >
                <button
                    type="button"
                    className="rt-rd-notes-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        setActiveNotesDocId(activeNotesDocId === uniqueId ? null : uniqueId);
                    }}
                >
                    <i className="fa fa-sticky-note-o mr-1" /> Notes
                </button>
            </OverlayTrigger>
        );
    };

    const requiredDocumentRefIds = new Set(
        reqDocs
            .filter((doc) => doc.refDocId > 0)
            .map((doc) => String(doc.refDocId))
    );

    const isVisibleAppDocument = (doc) => (
        !requiredDocumentRefIds.has(String(doc.uploadId)) &&
        doc.uploadType !== "agency" &&
        doc.uploadType !== "msp" &&
        doc.uploadType !== "Invoice" &&
        doc.uploadType !== "po" &&
        doc.uploadType !== "PO" &&
        doc.uploadType !== "client" &&
        doc.uploadType !== "project" &&
        doc.uploadType !== "ProjectInfo" &&
        doc.remarks !== "Time Sheet" &&
        doc.updType !== "Messaging" &&
        doc.updType !== "internal" &&
        doc.updType !== "Invoice" &&
        doc.updType !== "po" &&
        doc.updType !== "PO" &&
        doc.uploadType !== "Messaging" &&
        doc.uploadType !== "reporting" &&
        !doc.uploadType?.includes("req_") &&
        !doc.uploadType?.includes("ach_") &&
        !doc.uploadType?.includes("insurance_") &&
        !(doc.updType && doc.updType.includes("req_")) &&
        doc.deleteFlag !== true &&
        doc.docModifiedName !== "esign" &&
        !doc.docName?.toLowerCase().startsWith("purchase_order_")
    );

    const mergedDocs = [
        ...appDocuments
            .filter(
                (x) => isVisibleAppDocument(x)
            )
            .map((d) => ({
                ...d,
                type: "app",
                date: moment(d.dateTime)
            })),

        ...pOrders
            .filter((x) => x.sendStatus === true || x.partnerSign === true)
            .map((p) => ({
                ...p,
                poType: p.type,
                type: "po",
                date: moment(p.addedDateTime)
            })),

        ...reqDocs
            .filter((f) => f.deleteFlag !== true)
            .map((f) => ({
                ...f,
                type: "req",
                date: moment(f.addedDateTime)
            })),

        ...esignDocs
            .filter((f) => f.signedStatus === "1" || f.signedStatus === "Signed" || f.signedStatus === "Completed")
            .map((f) => ({
                ...f,
                type: "esign",
                date: moment(f.createdDateTime)
            }))
    ];

    const sortedDocs = mergedDocs.sort((a, b) => b.date - a.date);

    useEffect(() => {
        if (typeof onCountChange === 'function') {
            onCountChange(sortedDocs.length);
        }
    }, [sortedDocs.length, onCountChange]);

    const isDocumentSent = (doc) =>
        doc?.sentStatus === true ||
        doc?.sentStatus === "true" ||
        doc?.sentStatus === 1 ||
        doc?.sentStatus === "1" ||
        !!doc?.sentDateTime;

    const renderAppDocumentStatusBadge = (doc) => {
        if (isDocumentSent(doc)) {
            return (
                <span className="rt-rd-status-badge is-sent">
                    <i className="fa fa-arrow-up mr-1" aria-hidden="true" /> Sent
                </span>
            );
        }

        return (
            <span className="rt-rd-status-badge is-draft">
                <i className="fa fa-clock-o mr-1" aria-hidden="true" /> Not Sent
            </span>
        );
    };

    const renderCard = (doc) => {
        const notesContent = doc.type === "req" ? getReqUploadedNotes(doc) : (doc.remarks || doc.notes);

        return (
            <div className="rt-rd-row">
                {/* 1. Icon */}
                {doc.type === "app" && (
                    <div className="rt-rd-file-icon is-app" title="General Document">
                        <i className="fa fa-file-text-o" aria-hidden="true" />
                    </div>
                )}
                {doc.type === "po" && (
                    <div className="rt-rd-file-icon is-po" title="PO Document">
                        <i className="fa fa-file-pdf-o" aria-hidden="true" />
                    </div>
                )}
                {doc.type === "req" && (
                    <div className="rt-rd-file-icon is-req" title="Requested Document">
                        <i className="fa fa-folder-open-o" aria-hidden="true" />
                    </div>
                )}
                {doc.type === "esign" && (
                    <div className="rt-rd-file-icon is-esign" title="E-signed Document">
                        <i className="fa fa-pencil" aria-hidden="true" />
                    </div>
                )}

                {/* 2. File Name & Details */}
                <div className="rt-rd-file-main">
                    {doc.type === "app" && (
                        <button
                            className="rt-rd-doc-name-btn"
                            title="Download File"
                            onClick={() => handleDownloadFile(doc)}
                        >
                            {doc.docName}
                        </button>
                    )}

                    {doc.type === "po" && (
                        <button
                            className="rt-rd-doc-name-btn"
                            onClick={() => handleDownloadPoFile(doc, doc.partnerSign ? "partner" : "vendor")}
                            title="Download PO Document"
                        >
                            {doc.ipcsPoName || "PO Document"}
                        </button>
                    )}

                    {doc.type === "req" && (() => {
                        const refDocs = doc.refDocId > 0
                            ? appDocuments.filter((x) => x.uploadId === doc.refDocId && x.deleteFlag !== true)
                            : [];

                        if (refDocs.length > 0) {
                            return (
                                <div className="rt-rd-req-doc-stack">
                                    {refDocs.map((d) => (
                                        <div key={`ref-${d.docId}`} className="rt-rd-req-doc-line">
                                            <span className="rt-rd-mini-tag">Ref</span>
                                            <button
                                                className="rt-rd-doc-name-btn rt-rd-req-doc-link"
                                                onClick={() => handleDownloadFile(d)}
                                                title="Download Reference Document"
                                            >
                                                {d.docName}
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            );
                        }

                        return (
                            <span style={{ fontWeight: "500", color: "#1e293b", fontSize: "14px" }}>
                                {doc.documnetName}
                            </span>
                        );
                    })()}

                    {doc.type === "esign" && (
                        <div className="rt-rd-esign-actions">
                            <button
                                className="rt-rd-doc-name-btn"
                                disabled={(signLoading && selectedSignedDoc?.id === doc.id) || esignLinkLoadingKey === `${doc.id}-finalSigned`}
                                onClick={() => handleOpenReceivedEsignDocument(doc, "finalSigned")}
                                title="Open Digital Signed Document"
                            >
                                {esignLinkLoadingKey === `${doc.id}-finalSigned` ? (
                                    <><i className="fa fa-spinner fa-spin mr-1" /> Opening...</>
                                ) : (
                                    doc.documentName
                                )}
                            </button>
                        </div>
                    )}

                    <div className="rt-rd-doc-meta">
                        {/* Type badge */}
                        <span className="rt-rd-doc-type-badge">
                            {doc.type === "app" && "General"}
                            {doc.type === "po" && `PO - ${doc.poType === "subcontractor" ? "Subcontractor" : "Recruiter"}`}
                            {doc.type === "req" && (doc.documnetName || "Requested Document")}
                            {doc.type === "esign" && "E-signed"}
                        </span>

                        {/* Date & Time */}
                        <span className="rt-rd-doc-date">
                            <Moment format="MMM D, YYYY h:mm a">{doc.date}</Moment>
                        </span>

                        {/* File Size */}
                        {doc.type === "app" && doc.docSize && (
                            <span className="rt-rd-doc-size">
                                {doc.docSize}
                            </span>
                        )}
                        {doc.type === "esign" && doc.docSize && (
                            <span className="rt-rd-doc-size">
                                {doc.docSize}
                            </span>
                        )}
                        {doc.type === "req" && getReqUploadedSize(doc) && (
                            <span className="rt-rd-doc-size">
                                {getReqUploadedSize(doc)}
                            </span>
                        )}
                    </div>
                </div>

                {/* 4. Received Document Preview */}
                <div className="rt-rd-received-preview-col">
                    {doc.type === "req" && (() => {
                        const uploadedDocs = appDocuments.filter(
                            (x) => x.updType === `req_${!doc.id ? doc.docId : doc.id}` && x.deleteFlag !== true
                        );

                        if (uploadedDocs.length > 0) {
                            return uploadedDocs.map((d) => (
                                <button
                                    key={`received-preview-${d.docId}`}
                                    className="rt-rd-received-preview"
                                    onClick={() => handleDownloadFile(d)}
                                    title="Download Received Document"
                                >
                                    <span className="rt-rd-received-preview-title">
                                        <span>{d.docName}</span>
                                        <span className="rt-rd-status-badge is-received">
                                            <i className="fa fa-arrow-down" aria-hidden="true" /> Received
                                        </span>
                                    </span>
                                    <span className="rt-rd-received-preview-meta">
                                        <span>
                                            <Moment format="MMM D, YYYY h:mm a">{d.dateTime}</Moment>
                                        </span>
                                        {d.docSize && (
                                            <span>
                                                <i className="fa fa-hdd-o" aria-hidden="true" /> {d.docSize}
                                            </span>
                                        )}
                                    </span>
                                </button>
                            ));
                        }

                        return (
                            <button
                                type="button"
                                className="btn btn-sm btn-action-upload"
                                disabled={doc.sendStatus !== true}
                                onClick={() => {
                                    setUploadDocType(`req_${doc.id || doc.docId}`);
                                    setDocShowHide(true);
                                }}
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    padding: "7px 14px",
                                    borderRadius: "0",
                                    background: doc.sendStatus === true ? "var(--rd-primary)" : "#e2e8f0",
                                    color: doc.sendStatus === true ? "#ffffff" : "#64748b",
                                    border: doc.sendStatus === true ? "1px solid var(--rd-primary)" : "1px solid #cbd5e1",
                                    boxShadow: "0 2px 5px rgba(15, 23, 42, 0.08)",
                                    cursor: doc.sendStatus === true ? "pointer" : "not-allowed",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                                }}
                            >
                                <i className="fa fa-upload" aria-hidden="true" /> Upload
                            </button>
                        );
                    })()}
                </div>

                {/* 3. Notes Popover */}
                {notesContent ? (
                    <div className="rt-rd-notes-col">
                        {getPopover(notesContent, `${doc.type}_${doc.id || doc.docId}`)}
                    </div>
                ) : <div className="rt-rd-notes-placeholder" />}

                {/* 5. Sent/Received Badge */}
                <div className="rt-rd-status-col">
                    {doc.type === "app" && (
                        (doc.uploaderType === "WP" || doc.uploaderType === "Super Admin") ? (
                            renderAppDocumentStatusBadge(doc)
                        ) : (
                            <span className="rt-rd-status-badge is-received">
                                Received
                            </span>
                        )
                    )}
                    {doc.type === "po" && (
                        (doc.partnerSign || doc.partnerSignStatus === 1 || doc.esignStatus === "Signed" || doc.esignStatus === "Completed") ? (
                            <span className="rt-rd-status-badge is-received">
                                Received
                            </span>
                        ) : (doc.esignStatus || doc.eSignStatus) ? (
                            <span className="rt-rd-status-badge is-sent">
                                {doc.esignStatus || doc.eSignStatus}
                            </span>
                        ) : doc.sendStatus ? (
                            <span className="rt-rd-status-badge is-sent">
                                Sent
                            </span>
                        ) : (
                            <span className="rt-rd-status-badge is-draft">
                                Not Sent
                            </span>
                        )
                    )}
                    {doc.type === "req" && getReqStatusBadge(doc)}
                    {doc.type === "esign" && (
                        <span className="rt-rd-status-badge is-received">
                            Received
                        </span>
                    )}
                </div>

                {/* 6. Review Status Select Dropdown */}
                <div className="rt-rd-review-col">
                    {doc.type === "app" && (
                        <SelectStatusDropdownMenu
                            value={doc.docStatus}
                            onChange={(val) => handleDocStatusChange(doc.docId, val, "doc")}
                        />
                    )}
                    {doc.type === "po" && (
                        <div className="rt-rd-review-group" style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                            <EsignDropdownMenu
                                doc={doc}
                                handleOpenReceivedEsignDocument={handleOpenReceivedEsignDocument}
                                resolveReceivedEsignLinks={resolveReceivedEsignLinks}
                                getReceivedEsignToken={getReceivedEsignToken}
                            />

                            <SelectStatusDropdownMenu
                                value={doc.status}
                                onChange={(val) => handleDocStatusChange(doc.id, val, "po")}
                            />
                        </div>
                    )}
                    {doc.type === "req" && (
                        <SelectStatusDropdownMenu
                            value={doc.status}
                            onChange={(val) => handleDocStatusChange(doc.id, val, "req")}
                        />
                    )}
                    {doc.type === "esign" && (
                        <div className="rt-rd-review-group" style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                            <EsignDropdownMenu
                                doc={doc}
                                handleOpenReceivedEsignDocument={handleOpenReceivedEsignDocument}
                                resolveReceivedEsignLinks={resolveReceivedEsignLinks}
                                getReceivedEsignToken={getReceivedEsignToken}
                            />

                            <SelectStatusDropdownMenu
                                value={doc.signedDocStatus}
                                onChange={(val) => handleDocStatusChange(doc.id, val, "esign")}
                            />
                        </div>
                    )}
                </div>

                {/* 7. Delete Action */}
                <div className="rt-rd-delete-col">
                    {doc.type === "app" && (
                        <button
                            className="rt-rd-delete-btn"
                            title="Delete File"
                            onClick={() => handleDeleteFile(doc.docId, "doc")}
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    )}
                    {doc.type === "po" && (
                        <button
                            className="rt-rd-delete-btn"
                            title="Delete File"
                            onClick={() => handleDeleteFile(doc.id, "po")}
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    )}
                    {doc.type === "req" && getReqDeleteAction(doc)}
                    {doc.type === "esign" && (
                        <button
                            className="rt-rd-delete-btn"
                            title="Delete File"
                            onClick={() => handleDeleteFile(doc.id, "esign")}
                        >
                            <i className="fa fa-trash"></i>
                        </button>
                    )}
                </div>
            </div>
        );
    };

    if (isLoading || sortedDocs.length === 0) {
        return (
            <div className="rt-received-docs-panel">
                <style>{`
                    .rt-received-docs-panel {
                        --rd-primary: #2563eb;
                        --rd-bg-card: #ffffff;
                        --rd-text-dark: #1e293b;
                        --rd-text-muted: #64748b;
                        --rd-border: #cbd5e1;
                        --rd-radius: 0;

                        background: var(--rd-bg-card);
                        border: 1px solid var(--rd-border);
                        border-radius: var(--rd-radius);
                        box-shadow: 0 1px 3px rgba(0,0,0,0.02);
                        padding: 16px;
                        font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                        font-size: 14px;
                        color: #1e293b;
                    }
                    .rt-rd-empty {
                        text-align: center;
                        padding: 24px 20px;
                        color: #64748b;
                        background-color: #f8fafc;
                        border-radius: 0;
                        border: 1px dashed #cbd5e1;
                    }
                    .rt-rd-empty i {
                        font-size: 26px;
                        color: #cbd5e1;
                        margin-bottom: 8px;
                        display: block;
                    }
                    .rt-rd-empty.is-loading {
                        color: #64748b;
                    }
                    .rt-rd-empty.is-loading i {
                        color: var(--rd-primary);
                        font-size: 22px;
                    }
                    .rt-rd-empty-text {
                        font-size: 14px;
                        font-weight: 400;
                    }
                `}</style>
                {isLoading ? (
                    <div className="rt-rd-empty is-loading">
                        <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                        <div className="rt-rd-empty-text">Loading documents…</div>
                    </div>
                ) : (
                    <div className="rt-rd-empty">
                        <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                        <div className="rt-rd-empty-text">No received documents found.</div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="rt-received-docs-panel">
            <style>{`
                .rt-received-docs-panel {
                    --rd-primary: #2563eb;
                    --rd-primary-hover: #1d4ed8;
                    --rd-bg-card: #ffffff;
                    --rd-text-dark: #1e293b;
                    --rd-text-muted: #64748b;
                    --rd-border: #cbd5e1;
                    --rd-radius: 0;
                    
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    font-size: 14px;
                    color: #1e293b;
                }

                .rt-rd-list {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    margin-top: 8px;
                }

                .rt-rd-row {
                    display: grid;
                    grid-template-columns: 36px minmax(0, 1fr) minmax(0, 220px) auto auto auto auto;
                    align-items: center;
                    gap: 8px;
                    background: var(--rd-bg-card);
                    border: 1px solid #dbe3ef;
                    border-radius: 0;
                    padding: 16px;
                    transition: all 0.15s ease;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
                }

                .rt-rd-row:hover {
                    border-color: #bfdbfe;
                    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.08);
                }

                /* File Icon styling */
                .rt-rd-file-icon {
                    width: 36px;
                    height: 36px;
                    border-radius: 0;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    flex-shrink: 0;
                    background: #ffffff !important;
                    color: #1e293b !important;
                    border: 1px solid #cbd5e1 !important;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
                }

                .rt-rd-file-icon.is-esign,
                .rt-rd-file-icon.is-po,
                .rt-rd-file-icon.is-req,
                .rt-rd-file-icon.is-app {
                    background: #ffffff !important;
                    color: #1e293b !important;
                    border: 1px solid #cbd5e1 !important;
                }

                .rt-rd-file-main {
                    min-width: 0;
                }

                .rt-rd-doc-name-btn {
                    background: transparent;
                    border: none;
                    padding: 0;
                    margin: 0;
                    text-align: left;
                    font-size: 14px;
                    font-weight: 500;
                    color: var(--rd-primary);
                    cursor: pointer;
                    transition: color 0.15s ease;
                    line-height: 1.3;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                }

                .rt-rd-doc-name-btn:hover:not(:disabled) {
                    color: var(--rd-primary-hover);
                    text-decoration: underline;
                }

                .rt-rd-doc-name-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .rt-rd-req-doc-stack {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                    align-items: flex-start;
                }

                .rt-rd-req-doc-line {
                    display: grid;
                    grid-template-columns: 32px minmax(0, auto);
                    align-items: center;
                    column-gap: 7px;
                    max-width: 100%;
                }

                .rt-rd-mini-tag {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 32px;
                    height: 18px;
                    padding: 0 6px;
                    border-radius: 0;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    color: #64748b;
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 1;
                    text-transform: uppercase;
                }

                .rt-rd-mini-tag.is-received {
                    background: rgba(16, 185, 129, 0.08);
                    border-color: rgba(16, 185, 129, 0.18);
                    color: #047857;
                }

                .rt-rd-req-doc-link {
                    max-width: 360px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 14px;
                    line-height: 1.2;
                }

                .rt-rd-received-preview-col {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: center;
                    gap: 4px;
                    min-width: 0;
                }

                .rt-rd-received-preview {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 4px;
                    max-width: 220px;
                    padding: 0;
                    border: 0;
                    background: transparent;
                    color: var(--rd-primary);
                    cursor: pointer;
                    text-align: left;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                }

                .rt-rd-received-preview-title {
                    display: flex;
                    align-items: center;
                    gap: 7px;
                    width: 100%;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.2;
                }

                .rt-rd-received-preview-title span:first-child {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .rt-rd-received-preview-title span.rt-rd-status-badge {
                    flex-shrink: 0;
                    padding: 3px 8px;
                    font-size: 12px;
                    font-weight: 500;
                }

                .rt-rd-received-preview-meta {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    max-width: 100%;
                    padding-left: 0;
                    color: #64748b;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 1.2;
                    white-space: nowrap;
                }

                .rt-rd-received-preview:hover .rt-rd-received-preview-title span:first-child {
                    color: var(--rd-primary-hover);
                    text-decoration: underline;
                }

                .rt-rd-doc-meta {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-top: 4px;
                    flex-wrap: wrap;
                }

                .rt-rd-doc-date {
                    font-size: 11px !important;
                    font-weight: 400 !important;
                    color: #64748b !important;
                }

                .rt-rd-doc-size {
                    font-size: 11px !important;
                    font-weight: 400 !important;
                    color: #64748b !important;
                    display: inline-flex !important;
                    align-items: center !important;
                    gap: 3px !important;
                }
                .rt-rd-doc-date i,
                .rt-rd-doc-size i {
                    display: none !important;
                }

                .rt-rd-doc-type-badge {
                    font-size: 12px;
                    font-weight: 600;
                    color: #64748b;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    border-radius: 0;
                    padding: 1px 7px;
                    display: inline-block;
                    text-transform: uppercase;
                }

                /* Notes popover trigger styling */
                .rt-rd-notes-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    padding: 7px 14px;
                    border-radius: 0;
                    font-size: 14px;
                    font-weight: 500;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    min-height: 32px;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                }

                .rt-rd-notes-btn:hover {
                    background: #f8fafc;
                    color: #1e293b;
                    border-color: #94a3b8;
                    transform: translateY(-1px);
                    box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12);
                }

                /* Status Badges */
                .rt-rd-status-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    padding: 4px 10px;
                    border-radius: 0;
                    font-size: 14px;
                    font-weight: 500;
                    white-space: nowrap;
                }

                .rt-rd-status-badge.is-received {
                    color: #047857;
                    border: 1px solid rgba(16, 185, 129, 0.15);
                }

                .rt-rd-status-badge.is-sent {
                    color: #b45309;
                    border: 1px solid rgba(245, 158, 11, 0.2);
                }

                .rt-rd-status-badge.is-draft {
                    color: #64748b;
                    border: 1px solid rgba(100, 116, 139, 0.18);
                }

                /* Select Status & Dropdown buttons matching PurchaseOrderPopup */
                .rt-rd-select-status, select.rt-rd-select-status, button.rt-rd-select-status {
                    -webkit-appearance: none !important;
                    -moz-appearance: none !important;
                    appearance: none !important;
                    font-size: 14px !important;
                    color: #1e293b !important;
                    background-color: #ffffff !important;
                    border: 1px solid #cbd5e1 !important;
                    border-radius: 0 !important;
                    padding: 7px 14px !important;
                    outline: none !important;
                    transition: all 0.15s ease !important;
                    cursor: pointer !important;
                    min-width: 110px !important;
                    height: auto !important;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                    font-weight: 500 !important;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                }

                .rt-rd-select-status:hover,
                .rt-rd-select-status:focus {
                    background-color: #f8fafc !important;
                    border-color: #bfdbfe !important;
                    color: #1d4ed8 !important;
                    transform: translateY(-1px) !important;
                }

                .rt-rd-esign-dropdown-container,
                .rt-rd-status-dropdown-container,
                .rt-rd-esign-dropdown-container .rt-rd-select-status,
                .rt-rd-status-dropdown-container .rt-rd-select-status,
                .rt-rd-esign-popover-menu {
                    border-radius: 0 !important;
                }

                .rt-rd-status-dropdown-container .rt-rd-esign-popover-menu {
                    min-width: 165px !important;
                }

                .rt-rd-popover-item {
                    display: flex !important;
                    align-items: center !important;
                    padding: 7px 14px !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    color: #1e293b !important;
                    background: transparent !important;
                    border: none !important;
                    width: 100% !important;
                    text-align: left !important;
                    cursor: pointer !important;
                    text-decoration: none !important;
                    white-space: nowrap !important;
                    transition: all 0.15s ease !important;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                }

                .rt-rd-popover-item:hover {
                    background-color: #f8fafc !important;
                    color: #1d4ed8 !important;
                }

                /* Delete button matching PurchaseOrderPopup ghost-danger */
                .rt-rd-delete-btn, button.rt-rd-delete-btn {
                    -webkit-appearance: none !important;
                    -moz-appearance: none !important;
                    appearance: none !important;
                    background: rgba(239, 68, 68, 0.06) !important;
                    border: 1px solid rgba(239, 68, 68, 0.18) !important;
                    color: #dc2626 !important;
                    padding: 7px 14px !important;
                    border-radius: 0 !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    cursor: pointer !important;
                    transition: all 0.2s ease !important;
                    display: inline-flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 6px !important;
                    height: auto !important;
                    min-height: unset !important;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                }

                .rt-rd-delete-btn:hover {
                    background: rgba(239, 68, 68, 0.12) !important;
                    border-color: rgba(239, 68, 68, 0.28) !important;
                    color: #b91c1c !important;
                    transform: translateY(-1px) !important;
                }

                /* Popover custom styling to match Documents */
                .popover {
                    border-radius: 0 !important;
                    border: 1px solid #cbd5e1 !important;
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                    overflow: hidden;
                    z-index: 9999 !important;
                }
                .popover-header, .popover-title {
                    background: #f8fafc !important;
                    border-bottom: 1px solid #e2e8f0 !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    color: #1e293b !important;
                    padding: 10px 14px !important;
                }
            `}</style>
            <div className="rt-rd-list">
                {sortedDocs.map((doc, idx) => (
                    <React.Fragment key={`doc-${doc.type}-${doc.id || doc.docId || idx}`}>
                        {renderCard(doc)}
                    </React.Fragment>
                ))}
            </div>
            {docShowHide && (
                <CandidateReqDoc
                    docShowHide={docShowHide}
                    handleDocShowHide={handleDocShowHide}
                    workItem={workflowTask}
                    sendType="upload"
                    uploadType={getUploadType()}
                    applicantObj={item}
                    viewType=""
                    uploadDocType={uploadDocType}
                    prevItem={null}
                />
            )}
        </div>
    );
};

function EsignDropdownMenu({ doc, handleOpenReceivedEsignDocument, resolveReceivedEsignLinks, getReceivedEsignToken }) {
    const [open, setOpen] = useState(false);
    const [links, setLinks] = useState(null);
    const [loading, setLoading] = useState(false);
    const dropdownRef = useRef(null);

    const getEsignBaseUrl = () =>
        window.location.hostname === "localhost"
            ? "http://localhost:5173"
            : (process?.env?.REACT_APP_ESIGN_BASEURL || "http://localhost:5173");

    const getEsignApiBaseUrl = () =>
        process?.env?.REACT_APP_ESIGN_API_BASEURL ||
        process?.env?.REACT_APP_ESIGN_API_URL ||
        (window.location.hostname === "localhost" ? "http://localhost:5005" : getEsignBaseUrl());

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const toggleDropdown = async (e) => {
        e.stopPropagation();
        const nextOpen = !open;
        setOpen(nextOpen);
        if (nextOpen && !links) {
            setLoading(true);
            try {
                const resolved = await resolveReceivedEsignLinks(doc);
                setLinks(resolved);
            } catch (err) {
            } finally {
                setLoading(false);
            }
        }
    };

    const status = String(doc?.esignStatus || doc?.eSignStatus || "").replace(/\s+/g, "").toLowerCase();
    const isSigned = doc.type === "esign" || doc.partnerSign === true || doc.partnerSignStatus === 1 || status === "signed" || status === "completed";

    const token = getReceivedEsignToken(doc);
    const apiBase = getEsignApiBaseUrl();
    const esignBaseUrl = getEsignBaseUrl();

    const prepareUrl = links?.prepare || (token ? `${esignBaseUrl}/prepare/${token}` : "#");
    const detailsUrl = links?.details || (token ? `${esignBaseUrl}/documents/${token}/details` : "#");
    const logsUrl = links?.logs || (token ? `${esignBaseUrl}/documents/${token}/logs` : "#");
    const visibleSignedUrl = links?.visibleSigned || (token ? `${apiBase?.replace(/\/$/, "") || ""}/api/public/documents/${token}/download/visible-signed?inline=true` : "#");
    const finalSignedUrl = links?.finalSigned || (token ? `${apiBase?.replace(/\/$/, "") || ""}/api/public/documents/${token}/download/final-signed?inline=true` : "#");

    return (
        <div ref={dropdownRef} className="rt-rd-esign-dropdown-container" style={{ position: "relative", display: "inline-block" }}>
            <button
                type="button"
                className="rt-rd-select-status"
                onClick={toggleDropdown}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "6px",
                    minWidth: "100px",
                    cursor: "pointer"
                }}
            >
                <span style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                    <i className="fa fa-pencil-square-o" style={{ fontSize: "14px", color: "#64748b" }} />
                    eSign
                </span>
                <i className={`fa ${open ? "fa-caret-up" : "fa-caret-down"}`} style={{ fontSize: "14px", color: "#64748b" }} />
            </button>

            {open && (
                <div
                    className="rt-rd-esign-popover-menu"
                    style={{
                        position: "absolute",
                        right: 0,
                        top: "calc(100% + 4px)",
                        background: "#ffffff",
                        border: "1px solid #dbe3ef",
                        borderRadius: "8px",
                        boxShadow: "0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 8px 10px -6px rgba(15, 23, 42, 0.08)",
                        padding: "6px 0",
                        minWidth: "180px",
                        zIndex: 9999,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    {loading && (
                        <div style={{ padding: "8px 14px", fontSize: "14px", fontWeight: "400", color: "#64748b", display: "flex", alignItems: "center", gap: "6px" }}>
                            <i className="fa fa-spinner fa-spin" /> Loading...
                        </div>
                    )}

                    {!loading && (
                        <>
                            <a
                                className="rt-rd-popover-item"
                                href={prepareUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => setOpen(false)}
                            >
                                <i className="fa fa-pencil-square-o mr-2" style={{ color: "#1e293b" }} /> Prepare
                            </a>
                            <a
                                className="rt-rd-popover-item"
                                href={detailsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => setOpen(false)}
                            >
                                <i className="fa fa-info-circle mr-2" style={{ color: "#1e293b" }} /> Details
                            </a>
                            <a
                                className="rt-rd-popover-item"
                                href={logsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => setOpen(false)}
                            >
                                <i className="fa fa-history mr-2" style={{ color: "#1e293b" }} /> Log
                            </a>

                            {!isSigned && (
                                <>
                                    <div style={{ height: "1px", background: "#f1f5f9", margin: "4px 0" }} />
                                    <button
                                        type="button"
                                        className="rt-rd-popover-item text-left"
                                        onClick={() => {
                                            setOpen(false);
                                            handleOpenReceivedEsignDocument(doc, "sign");
                                        }}
                                    >
                                        <i className="fa fa-pencil-square-o mr-2" style={{ color: "#1e293b" }} /> Sign the Document
                                    </button>
                                </>
                            )}

                            {isSigned && (
                                <>
                                    <div style={{ height: "1px", background: "#f1f5f9", margin: "4px 0" }} />
                                    <a
                                        className="rt-rd-popover-item"
                                        href={visibleSignedUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => setOpen(false)}
                                    >
                                        <i className="fa fa-file-pdf-o mr-2" style={{ color: "#1e293b" }} /> Visible Signed
                                    </a>
                                    <button
                                        type="button"
                                        className="rt-rd-popover-item text-left"
                                        onClick={() => {
                                            setOpen(false);
                                            handleOpenReceivedEsignDocument(doc, "finalSigned");
                                        }}
                                    >
                                        <i className="fa fa-certificate mr-2" style={{ color: "#1e293b" }} /> Digital Signed
                                    </button>
                                </>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

function SelectStatusDropdownMenu({ value, onChange, title = "Status" }) {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const getStatusLabel = () => {
        if (String(value) === "1") return "Approved";
        if (String(value) === "0") return "Not Approved";
        return "Status";
    };

    const getStatusIcon = () => {
        if (String(value) === "1") return "fa-check-circle";
        if (String(value) === "0") return "fa-times-circle";
        return "fa-sliders";
    };

    const getStatusIconColor = () => {
        if (String(value) === "1") return "#16a34a";
        if (String(value) === "0") return "#dc2626";
        return "#64748b";
    };

    return (
        <div ref={dropdownRef} className="rt-rd-status-dropdown-container" style={{ position: "relative", display: "inline-block" }}>
            <button
                type="button"
                className="rt-rd-select-status"
                onClick={() => setOpen(!open)}
                title={title}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "6px",
                    minWidth: "100px",
                    cursor: "pointer"
                }}
            >
                <span style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
                    <i className={`fa ${getStatusIcon()}`} style={{ fontSize: "14px", color: getStatusIconColor() }} />
                    {getStatusLabel()}
                </span>
                <i className={`fa ${open ? "fa-caret-up" : "fa-caret-down"}`} style={{ fontSize: "14px", color: "#64748b" }} />
            </button>

            {open && (
                <div
                    className="rt-rd-esign-popover-menu"
                    style={{
                        position: "absolute",
                        right: 0,
                        top: "calc(100% + 4px)",
                        background: "#ffffff",
                        border: "1px solid #dbe3ef",
                        borderRadius: "8px",
                        boxShadow: "0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 8px 10px -6px rgba(15, 23, 42, 0.08)",
                        padding: "6px 0",
                        minWidth: "135px",
                        zIndex: 9999,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <button
                        type="button"
                        className="rt-rd-popover-item"
                        onClick={() => {
                            setOpen(false);
                            onChange("");
                        }}
                    >
                        <i className="fa fa-sliders mr-2" style={{ color: "#64748b" }} /> Status
                    </button>
                    <button
                        type="button"
                        className="rt-rd-popover-item"
                        onClick={() => {
                            setOpen(false);
                            onChange("1");
                        }}
                    >
                        <i className="fa fa-check-circle mr-2" style={{ color: "#16a34a" }} /> Approved
                    </button>
                    <button
                        type="button"
                        className="rt-rd-popover-item"
                        onClick={() => {
                            setOpen(false);
                            onChange("0");
                        }}
                    >
                        <i className="fa fa-times-circle mr-2" style={{ color: "#dc2626" }} /> Not Approved
                    </button>
                </div>
            )}
        </div>
    );
}

export default ReceivedDocuments;
